<template>
  <div class="video">
    <video playsinline autoplay muted loop class="video__placeholder" alt="asset-1">
      <source src="./../assets/v2.0/asset-1.webm" type="video/webm" />
      <source src="./../assets/v2.0/asset-1.mp4" type="video/mp4" />
      {{ $t('video_no_support') }}
    </video>

    <div class="video__play">
      <img
        src="../assets/v2.0/play.svg"
        alt="play button"
        class="play__button"
        @click="openVideo"
      />
    </div>

    <transition name="bounce">
      <div v-show="isShowingVideo" class="video__container">
        <i class="icon x16 icon_16_close_gray icon_close" @click="closeVideo"></i>
        <video v-if="shouldRenderVideo" id="video" controls>
          <source src="../assets/v2.0/tich.webm" type="video/webm" />
          <source src="../assets/v2.0/tich.mp4" type="video/mp4" />
          {{ $t('video_no_support') }}
        </video>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TheVideo',
  data() {
    return {
      isShowingVideo: false,
      shouldRenderVideo: false,
    }
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    closeVideo() {
      this.isShowingVideo = false
      document.querySelector('#video').pause()
      document.querySelector('#video').currentTime = 0
    },
    openVideo() {
      this.shouldRenderVideo = true
      this.isShowingVideo = true
      document.querySelector('#video').play()
    },
    handleKeyDown(e) {
      if (['input', 'textarea'].includes(e.target.tagName.toLowerCase())) return
      if (e.key.toLowerCase() === 'escape' && this.isShowingVideo) this.closeVideo()
    },
  },
}
</script>

<style lang="scss" scoped>
.video {
  position: relative;

  &__placeholder {
    width: 100%;
    border-radius: 10px;
    z-index: 1;
    display: block;
  }

  &__play {
    position: absolute;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75));
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: all 500ms;
    border-radius: 10px;

    &:hover {
      opacity: 1;
    }
  }

  &__container {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    border-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    display: flex;
    flex-flow: row-reverse;
    padding: 16px;

    & video {
      border-radius: 10px;
      width: 80%;
      margin: auto;
    }

    & .icon_close {
      z-index: 4;
      align-self: baseline;
      cursor: pointer;
    }
  }
}

.play__button {
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  .video {
    padding: 0 !important;
    &__placeholder {
      border-radius: 0;
    }

    &__play {
      border-radius: 0;
    }

    &__container {
      flex-flow: column;
      padding: 0;
      & .icon_close {
        align-self: flex-end;
        margin: 16px;
      }

      video {
        width: 100%;
        border-radius: 0;
      }
    }
  }
}
</style>
